import User from "../types/User";

export const login = async (identifier: string, password: string): Promise<{user: User, token: string}> => {
  const response = await fetch('/api/user/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ identifier, password }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Login failed')
  }

  return data;
};

export const register = async (
  user_name: string, 
  phone: string,
  password: string,
  radius: string,
  latitude: number | null,
  longitude: number | null,
  idToken: string
): Promise<{user: User, token: string}> => {
  const response = await fetch('/api/user/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      user_name, 
      phone, 
      password, 
      radius,
      latitude, 
      longitude,
      idToken
    }),
  });

  if (!response.ok) {
    throw new Error('Register failed')
  }

  return await response.json();
};

export const checkUsername = async (username: string): Promise<{ available: boolean}> => {
  const response = await fetch('/api/user/check-username', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_name: username }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error('Error checking username')
  }

  return data.available;
};

export const checkPhonenumberAvailability = async (phone: string): Promise<{ available: boolean}> => {
  const response = await fetch('/api/user/check-phone', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phone, checkType: 'availability' }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error('Error checking phonenumber')
  }

  return data.available;
};

export const checkPhoneNumberExists = async (phone: string): Promise<{ exists: boolean}> => {
  const response = await fetch('/api/user/check-phone', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phone, checkType: 'exists' }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error('Error checking phonenumber')
  }

  return data.exists;
};

export const resetPassword = async (
  normalizedPhone: string, 
  newPassword: string, 
  idToken: string
): Promise<void> => {
  const response = await fetch(`/api/user/${normalizedPhone}/newpassword`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ newPassword: newPassword, idToken }),
  });

  if (!response.ok) {
    throw new Error('Failed to reset password')
  }
}